import { useEffect, useState } from 'react';

/**
 * `value` as it stands once it has been still for `delay` ms.
 *
 * For anything that turns a keystroke into a request: hold the typed value in
 * state, query on the debounced one. Typing is not a page of results each
 * keystroke.
 */
export default function useDebounced<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return settled;
}
